import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TableComponent } from "../../../shared/components/table/table.component";
import { NavbarComponent } from "../../../template/components/navbar/navbar.component";
import { UserService } from '../../services/user.service';
import { UsersListElem } from '../../models/user.model';
import { ToastService } from '../../../shared/services/toast.service';
import { finalize, forkJoin } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModal } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { Column } from '../../../shared/models/column.model';

@Component({
  selector: 'app-user-list',
  imports: [TableComponent, NavbarComponent],
  templateUrl: './user-list.component.html'
})
export class UserListComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly userSrv = inject(UserService);
  private readonly toastSrv = inject(ToastService);
  private readonly modalSrv = inject(NgbModal);

  private users: UsersListElem[] = [];
  searchValue!: string;
  loading: boolean = false;

  navList = [{ label: 'Lista Utenti', routePath: '/users' }];

  userColumns: Column[] = [
    { label: 'Id', key: 'uid', type: 'hidden' },
    { label: 'Nome', key: 'name', type: 'string' },
    { label: 'Cognome', key: 'surname', type: 'string' },
    { label: 'Email', key: 'email', type: 'email' },
    { label: 'Telefono', key: 'telephone', type: 'string' },
    { label: 'Data Inserimento', key: 'createDate', type: 'date' },
    { label: 'Disabilitato', key: 'disabled', type: 'boolean' },
    { label: 'Account Attivato', key: 'emailVerified', type: 'boolean' },
    { label: 'Gruppi', key: 'groupList', type: 'list' },
    { label: 'Contesti', key: 'contextList', type: 'list' }
  ];

  ngOnInit(): void {
    this.apiGetUsers();
  }

  private apiGetUsers() {
    this.loading = true;
    this.userSrv.listAdminUsers()
      .pipe(finalize(() => this.loading = false))
      .subscribe(users => this.users = users);
  }

  get filteredUsers() {
    if (!this.searchValue) {
      return this.users;
    } else {
      return this.users.filter(user =>
        user.name.toLowerCase().includes(this.searchValue.toLowerCase()) ||
        user.surname.toLowerCase().includes(this.searchValue.toLowerCase()) ||
        user.email.toLowerCase().includes(this.searchValue.toLowerCase())
      );
    }
  }

  deleteUsers(users: UsersListElem[]): void {
    const modalRef = this.modalSrv.open(ConfirmModal, { centered: true, windowClass: 'qai-modal' });
    modalRef.componentInstance.title = 'Elimina Utenti';
    modalRef.componentInstance.body = 'Stai eliminando gli utenti:';
    modalRef.componentInstance.list = users.map(el => `${el.name} ${el.surname} (${el.email})`);
    modalRef.result.then(
      (result) => {
        this.apiDeleteUsers(users);
        console.log(`Closed with: ${result}`);
      },
      (reason) => {
        console.log(`Dismissed`);
      },
    );
  }

  private apiDeleteUsers(users: UsersListElem[]) {
    const deleteRequests = users.map(user => this.userSrv.deleteUser(user.uid));

    forkJoin(deleteRequests).subscribe(
      {
        next: () => {
          this.toastSrv.show({ type: 'success', message: 'Utenti eliminati con successo' });
          this.apiGetUsers();
        },
        error: (error) => {
          console.error('Error during multiple user deletion:', error);
          this.toastSrv.show({ type: 'error', message: 'Errore durante l\'eliminazione di alcuni utenti' });
        }
      });
  }

  openUserDetail(user: UsersListElem): void {
    this.router.navigate(['/users', user.uid]);
  }

  navigateDetail(detail: { item: { id: string, name: string }, colKey: string }): void {
    if (detail.colKey === 'groupList') {
      this.router.navigate(['/groups', detail.item.id]);
    } else if (detail.colKey === 'contextList') { 
      this.router.navigate(['/contexts', detail.item.id]);
    }
  }
}
